import {
    VIRTUAL_DEPART_DRIVER_SUCCESS,
    VIRTUAL_DEPART_DRIVER_ERROR,
    RESPONSE_TYPE
} from "../constants/VirtualDepartDriverConstants";
import {NDVSClient} from "../../client/NDVSClient";

export function virtualDepartDriverNetwork(driverId, dispatcher) {
    NDVSClient.virtualDepartDriver({
        driverId : driverId
    }).then(({valid, data}) => {
        console.log("virtualDepartDriverNetwork", valid, data, dispatcher);
        if (valid) {
            try {
                dispatcher({
                    type: VIRTUAL_DEPART_DRIVER_SUCCESS,
                    data: {
                        message: data.responseMessage,
                        alertType: RESPONSE_TYPE[data.responseType]
                    }

                })
            } catch (e) {
                dispatcher({
                    type: VIRTUAL_DEPART_DRIVER_ERROR,
                    data: {
                        message: data.responseMessage,
                        alertType: RESPONSE_TYPE.ERROR
                    }
                })
            }
        } else {
            dispatcher({
                type: VIRTUAL_DEPART_DRIVER_ERROR,
                data: {
                    message: data.responseMessage,
                    alertType: RESPONSE_TYPE.ERROR
                }
            })
        }
    });
}


// WEBPACK FOOTER //
// ./src/components/virtualDepartDriver/network/VirtualDepartDriverNetwork.js